export default __webpack_public_path__ + "card-amex.png";